const MONTH_LABELS = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'
];

const toMonthStart = (value) => {
  if (!value) return null;
  const date = new Date(`${String(value).slice(0, 10)}T12:00:00`);
  return Number.isNaN(date.getTime()) ? null : new Date(date.getFullYear(), date.getMonth(), 1);
};

export const formatSubscriptionDate = (value) => {
  const date = toMonthStart(value);
  return date
    ? new Date(`${String(value).slice(0, 10)}T12:00:00`).toLocaleDateString('es-UY')
    : 'Sin fecha configurada';
};

/**
 * Builds an operational ledger: one row per month from the commercial start
 * (or account creation) to the current month.  Missing invoices remain
 * visible as "SIN_REGISTRO" so they are not confused with an unpaid charge.
 */
export const buildMonthlyBillingPeriods = (invoices = [], startDate, today = new Date()) => {
  const byPeriod = new Map(
    invoices.map((invoice) => [`${invoice.periodYear}-${invoice.periodMonth}`, invoice])
  );
  const earliestInvoice = invoices.reduce((earliest, invoice) => {
    const candidate = new Date(invoice.periodYear, invoice.periodMonth - 1, 1);
    return !earliest || candidate < earliest ? candidate : earliest;
  }, null);
  const start = toMonthStart(startDate) || earliestInvoice;
  if (!start) return [];

  const end = new Date(today.getFullYear(), today.getMonth(), 1);
  if (start > end) return [];

  const rows = [];
  for (let cursor = new Date(start); cursor <= end; cursor = new Date(cursor.getFullYear(), cursor.getMonth() + 1, 1)) {
    const year = cursor.getFullYear();
    const month = cursor.getMonth() + 1;
    const invoice = byPeriod.get(`${year}-${month}`);
    rows.push({
      id: invoice?.id ?? `missing-${year}-${month}`,
      periodYear: year,
      periodMonth: month,
      periodLabel: `${MONTH_LABELS[month - 1]} ${year}`,
      status: invoice?.status || 'SIN_REGISTRO',
      invoice: invoice || null
    });
  }
  return rows.reverse();
};

export const MONTHLY_STATUS_OPTIONS = [
  { value: 'PENDING', label: 'Pendiente' },
  { value: 'PAID', label: 'Pagado' },
  { value: 'REJECTED_FINAL', label: 'Rechazado final' }
];
